/**
 * "Open the room template chooser" requests from outside the component
 * that owns it (`RoomTemplateSheet`, mounted in `App.tsx`). The feng shui
 * landing's "Now fix my room", the 3D first run's "Try it on my room" and
 * both guides' "Start my room" use it, so going from the example to a
 * furnished room of your own is one tap. `kind` picks the tab it opens on.
 */

export type RoomTemplateKind = "bedroom" | "living";

export interface RoomTemplateRequest {
  kind?: RoomTemplateKind;
}

let pending: RoomTemplateRequest | null = null;
const listeners = new Set<(req: RoomTemplateRequest) => void>();

function flush() {
  if (!pending || listeners.size === 0) return;
  const req = pending;
  pending = null;
  for (const l of listeners) l(req);
}

export function requestRoomTemplates(req: RoomTemplateRequest = {}): void {
  pending = req;
  flush();
}

export function subscribeRoomTemplateRequests(listener: (req: RoomTemplateRequest) => void): () => void {
  listeners.add(listener);
  if (pending) queueMicrotask(flush);
  return () => {
    listeners.delete(listener);
  };
}

/** Test-only: drop an undelivered request. */
export function _resetRoomTemplateRequestsForTests(): void {
  pending = null;
}
